/* eslint-disable @typescript-eslint/no-unused-vars */

import {
    SliceFactory,
    FetchCollectionData,
    FetchItemDataType,
    ApiCollectionResponse,
} from '@europrocurement/l2d-redux-utils';
import {
    ConfigurationParameters as AchatsConfigurationParameters,
    Configuration,
    ReminderPublisherJsonldReminderPublisherReadTimestampableBlameambleGroupSocieteAwareGroup,
    ReminderPublisherApi,
    ReminderPublisherApiGetReminderPublisherCollectionRequest,
} from '../../../openApi/ApiAchats';
import { ACHATS_REDUCER_NAME } from '../constants';
import { Order } from '../../../types/apiGenericTypes';

export type ReminderPublisherApiObject =
    ReminderPublisherJsonldReminderPublisherReadTimestampableBlameambleGroupSocieteAwareGroup &
        Record<string, unknown>;

export type ReminderPublisher = ReminderPublisherApiObject;

export const REMINDER_PUBLISHER_SLICE_NAME = 'reminderPublisher';

export const additionalRemindersPublishersDataSources: Array<string> = [];

const mapperReminderPublisher = function (reminderPublisher: ReminderPublisher) {
    return {
        ...reminderPublisher,
    } as ReminderPublisher;
};

export const ReminderPublisherStatus = {
    PENDING: 'pending',
    ERROR: 'error',
    SENT: 'sent',
} as const;

export type ReminderPublisherStatusType =
    (typeof ReminderPublisherStatus)[keyof typeof ReminderPublisherStatus];

export function createReminderPublisherSlice(configuration: AchatsConfigurationParameters) {
    const conf = new Configuration(configuration);
    const api = new ReminderPublisherApi(conf);

    const fetchReminderPublisherCollection: FetchCollectionData<ReminderPublisher> = ({
        search,
        pagination,
        filters,
        orders,
        xIdSociete,
        rootstate,
    }) => {
        let fournisseurId: string | undefined;
        let status2: string[] | undefined;
        let tags: Array<string> | undefined;
        let orderId: Order;
        let orderStatus: Order;
        let orderCreatedAt: Order;

        const STATUS = Object.values(ReminderPublisherStatus);

        // const statusesFromFilters = filters.statuses as string;

        // if (statusesFromFilters) {
        //     const inputStatuses = statusesFromFilters
        //         .split(',')
        //         .map((status) => status.toLowerCase().trim())
        //         .filter((value, index, self) => self.indexOf(value) === index);

        //     const validStatuses = inputStatuses.filter((status) =>
        //         STATUS.includes(status as ReminderPublisherStatusType),
        //     );

        //     statuses = validStatuses.length > 0 ? (validStatuses as typeof statuses) : undefined;
        // }

        if (filters.fournisseurId) {
            fournisseurId = filters.fournisseurId as string;
        }

        if (filters.status2 && Array.isArray(filters.status2) && filters.status2.length > 0) {
            status2 = filters.status2;
        }

        if (filters.tags && Array.isArray(filters.tags) && filters.tags.length > 0) {
            tags = filters.tags;
        }

        orders.forEach((item) => {
            if (item.field === 'id') {
                orderId = item.value;
            }
            if (item.field === 'status') {
                orderStatus = item.value;
            }
            if (item.field === 'createdAt') {
                orderCreatedAt = item.value;
            }
        });

        const requestParameters: ReminderPublisherApiGetReminderPublisherCollectionRequest = {
            xIdSociete,
            page: pagination.page + 1,
            itemsPerPage: pagination.itemsPerPage,
            fournisseurId,
            status2,
            orderId,
            orderStatus,
            orderCreatedAt,
        };

        return api
            .getReminderPublisherCollection(requestParameters)
            .then((res) => res.data) as Promise<ApiCollectionResponse<ReminderPublisher>>;
    };

    const fetchReminderPublisherItem: FetchItemDataType<ReminderPublisher> = ({
        idItem,
        search,
        pagination,
        filters,
        orders,
        xIdSociete,
        rootstate,
    }) =>
        api
            .getReminderPublisherItem({
                id: String(idItem),
                xIdSociete,
            })
            .then((res) => res.data) as Promise<ReminderPublisher>;

    const { slice: reminderPublisherSlice, dataSourcesThunks: reminderPublisherDataSourcesThunks } =
        SliceFactory.createSlice<ReminderPublisher, ReminderPublisher>(
            REMINDER_PUBLISHER_SLICE_NAME,
            ACHATS_REDUCER_NAME,
            additionalRemindersPublishersDataSources,
            fetchReminderPublisherCollection,
            fetchReminderPublisherItem,
            mapperReminderPublisher,
            {
                cloture: true,
                deleted: false,
            },
            undefined,
            [
                {
                    field: 'updatedAt',
                    value: 'desc',
                },
            ],
        );

    return { reminderPublisherSlice, reminderPublisherDataSourcesThunks };
}
